/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { UserGroupOptionFragmentDoc } from './UserGroupOptionFragment.hook'

const defaultOptions = {} as const
export type BackofficeUserManagementUserFormDetailsQueryVariables =
  Types.Exact<{ [key: string]: never }>

export type BackofficeUserManagementUserFormDetailsQuery = {
  __typename?: 'Query'
  backofficeUserManagementUserFormDetails: {
    __typename?: 'BackofficeUserManagementUserFormDetails'
    operatorTenants: Array<string> | null
    customerTenants: Array<string> | null
    ridepoolingServiceTenants: Array<string> | null
    groups: Array<{
      __typename?: 'BackofficeUserManagementGroup'
      critical: boolean
      gdpr: boolean
      name: string
      displayName: string
      assignedOrganizations: Array<string> | null
    }>
    approvers: Array<{
      __typename?: 'BackofficeUserManagementGroup'
      critical: boolean
      gdpr: boolean
      name: string
      displayName: string
      assignedOrganizations: Array<string> | null
    }>
    fleets: Array<{
      __typename?: 'BackofficeUserManagementFleet'
      id: string
      name: string
      operatorTenant: string
    }>
    serviceAreaDetails: Array<{
      __typename?: 'ServiceArea'
      uuid: string
      ridepoolingServiceTenant: string
      displayNames: Partial<Record<'de' | 'en', string>>
    } | null>
  }
}

export const BackofficeUserManagementUserFormDetailsDocument = gql`
    query backofficeUserManagementUserFormDetails {
  backofficeUserManagementUserFormDetails {
    groups {
      ...UserGroupOption
    }
    approvers {
      ...UserGroupOption
    }
    operatorTenants
    customerTenants
    ridepoolingServiceTenants
    fleets {
      id
      name
      operatorTenant
    }
    serviceAreaDetails {
      uuid
      ridepoolingServiceTenant
      displayNames
    }
  }
}
    ${UserGroupOptionFragmentDoc}`

/**
 * __useBackofficeUserManagementUserFormDetailsQuery__
 *
 * To run a query within a React component, call `useBackofficeUserManagementUserFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementUserFormDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeUserManagementUserFormDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackofficeUserManagementUserFormDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >(BackofficeUserManagementUserFormDetailsDocument, options)
}
export function useBackofficeUserManagementUserFormDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >(BackofficeUserManagementUserFormDetailsDocument, options)
}
// @ts-ignore
export function useBackofficeUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserManagementUserFormDetailsQuery,
  BackofficeUserManagementUserFormDetailsQueryVariables
>
export function useBackofficeUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserManagementUserFormDetailsQuery,
        BackofficeUserManagementUserFormDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackofficeUserManagementUserFormDetailsQuery | undefined,
  BackofficeUserManagementUserFormDetailsQueryVariables
>
export function useBackofficeUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeUserManagementUserFormDetailsQuery,
        BackofficeUserManagementUserFormDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >(BackofficeUserManagementUserFormDetailsDocument, options)
}
export type BackofficeUserManagementUserFormDetailsQueryHookResult = ReturnType<
  typeof useBackofficeUserManagementUserFormDetailsQuery
>
export type BackofficeUserManagementUserFormDetailsLazyQueryHookResult =
  ReturnType<typeof useBackofficeUserManagementUserFormDetailsLazyQuery>
export type BackofficeUserManagementUserFormDetailsSuspenseQueryHookResult =
  ReturnType<typeof useBackofficeUserManagementUserFormDetailsSuspenseQuery>
export type BackofficeUserManagementUserFormDetailsQueryResult =
  Apollo.QueryResult<
    BackofficeUserManagementUserFormDetailsQuery,
    BackofficeUserManagementUserFormDetailsQueryVariables
  >
